import { render, staticRenderFns } from "./BenefitCards.vue?vue&type=template&id=0e0e4640&scoped=true"
import script from "./BenefitCards.vue?vue&type=script&lang=js"
export * from "./BenefitCards.vue?vue&type=script&lang=js"
import style0 from "./BenefitCards.vue?vue&type=style&index=0&id=0e0e4640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0e4640",
  null
  
)

export default component.exports